<template>
  <div ref="body" />
</template>

<script setup lang="ts">
import DOMPurify from 'dompurify'
import { onMounted } from 'vue'
import { useTemplateRef } from 'vue'

const body = useTemplateRef<HTMLElement>('body')

DOMPurify.addHook('afterSanitizeAttributes', node => {
  // Set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank')
  }
})

onMounted(() => {
  fetch(import.meta.env.VITE_BROADLY_REVIEWS)
    .then(resp => {
      return resp.text()
    })
    .then(text => {
      const fragment = DOMPurify.sanitize(text, {
        RETURN_DOM_FRAGMENT: true,
        USE_PROFILES: { html: true, svg: true }
      })

      body.value?.appendChild(fragment)
    })
})
</script>
